"use strict";
/**
 * API Stubs - Placeholder declarations
 *
 * These functions and constants must be implemented by the consuming application.
 * This file provides TypeScript declarations to satisfy the type checker,
 * but the actual implementations should come from the consuming app's API layer.
 *
 * The consuming application should provide implementations for:
 * - BDO API calls (getKeoData, getKpoData, etc.)
 * - Configuration constants (TimeDelayInMs)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeDelayInMs = void 0;
/**
 * Delay in milliseconds between API pagination requests
 * Should be defined by consuming application to avoid rate limiting
 */
exports.TimeDelayInMs = 100; // Default placeholder value
//# sourceMappingURL=api-stubs.js.map